import { useCallback } from 'react'

import { SnackbarTypes, snackbarDurationDefault, useSnackbar } from './useSnackbar'
import { translate } from '../lib/localization'
import dayjs from '../lib/dayJs'

const CLIENTI_READ_ONLY_FROM = dayjs('2025-12-15')

export const isClientiReadOnly = (now = dayjs()) => now.isSameOrAfter(CLIENTI_READ_ONLY_FROM, 'day')

export const useReadOnlyGuard = () => {
  const [openSnackbar] = useSnackbar(SnackbarTypes.error)

  return useCallback(() => {
    if (isClientiReadOnly()) {
      openSnackbar(
        translate('read_only__clienti_snackbar_message'),
        snackbarDurationDefault
      )
      return true
    }

    return false
  }, [openSnackbar])
}

export const READ_ONLY_FROM = CLIENTI_READ_ONLY_FROM
